import FiveTwoNineBenefits from 'tio-employee/components/five-two-nine/benefits';

<template><FiveTwoNineBenefits /></template>
